
import clsx from "classnames";
import P from "components/P";
import SkeletonImage from "components/skeleton/SkeletonImage";
import SkeletonText from "components/skeleton/SkeletonText";
import Inline from "layouts/container/Inline";
import FlexChild from "layouts/flex/FlexChild";
import VerticalFlex from "layouts/flex/VerticalFlex";
import Center from "layouts/wrapper/Center";
import PaddingWrapper from "layouts/wrapper/PaddingWrapper";
import SquareWrapper from "layouts/wrapper/SquareWrapper";
import { AuthContext } from 'providers/AuthProvider';
import { useContext } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { addCommas } from "shared/utils/Utils";
import style from "./SimpleProductCard.module.css";

function SimpleProductCard(props) { 
    const { data, type, skeleton } = props;
    const {userName} = useContext(AuthContext);
    const { t } = useTranslation();
    const navigate = useNavigate();

    const onProductClick = () => {
        navigate(`/product/detail/${data.id}/#`);
    }

    const GiftSticker = () => {
        return (
            <>
                {
                    data.gift &&
                    <div style={{ width: 30, height: 30, position: "absolute", top: 0, right: 0, zIndex: 100, backgroundColor: "#0a8fff", borderRadius: "100%", padding: "0px 0px" }}>
                        <Center>
                            <P size={10} weight={800} color={"white"}>{`${data.giftStandard} + ${data.gift}`}</P>
                        </Center>
                    </div>
                }
            </>
        );
    }


    return (
        <div className={clsx(style.wrap, { [style.horizontal]: type === "horizontal" })} onClick={onProductClick}>
            {
                data &&
                <VerticalFlex>
                    <FlexChild >
                        {
                            skeleton ?
                                <div className={style.thumbnail} style={{ backgroundColor: "#ebebeb" }}>
                                    <SquareWrapper>
                                        {
                                            skeleton ? <SkeletonImage width={100} />
                                                : <img className={style.image} src={data.thumbnail} alt={""} />
                                        }
                                    </SquareWrapper>
                                </div>
                                :
                                <div className={style.thumbnail} >
                                    <GiftSticker />
                                    <SquareWrapper>
                                        <img className={style.image} src={data.thumbnail} alt={""} />
                                    </SquareWrapper>
                                </div>
                        }
                    </FlexChild >
                    <FlexChild height={"fit-content"} backgroundColor={"white"}>
                        <PaddingWrapper padding={"5% 10% 5% 10%"}>
                            {
                                skeleton ?
                                    <Center width={"100%"} textAlign={"left"}>
                                        <SkeletonText width={50} size={16} />
                                        <SkeletonText width={50} size={16} />
                                        <SkeletonText width={50} size={16} />
                                        <Inline>
                                            <SkeletonText width={50} size={10} />
                                            <SkeletonText width={50} size={10} />
                                            <SkeletonText width={50} size={10} />
                                        </Inline>
                                        <SkeletonText width={50} size={10} />
                                        <SkeletonText width={50} size={10} />
                                    </Center>
                                    :
                                    <Center textAlign={"left"}>
                                        <P ellipsis size={11} weight={"900"}>{data?.title}</P>
                                        {/* <P textAlign={"left"} size={"12px"} color={"var(--main-color)"}>&#8361; {userName?addCommas(data?.prices[0]?.amount):"-"}</P> */}
                                    </Center>
                            }
                        </PaddingWrapper>
                    </FlexChild>
                </VerticalFlex>
            }
        </div>
    );
}

export default SimpleProductCard;